import { gql } from '@apollo/client';
import { UTILITY_FRAGMENT } from '~/services/fetch-utility/fetch-utility.queries';

export const FUNNEL_PACKET_FRAGMENT = gql`
  fragment FunnelPacketData on FunnelPacket {
    customPlan {
      id
      paymentMethodId
      planTemplate {
        id
        billingExperienceType
      }
    }
    signedContractIds
    funnelVnmProjectId
    nonLmi
    inviteCode
    funnelEnrollmentExperience
    utilityAccount {
      id
      communitySolarProjectGroup {
        id
        usesIpaContracts
      }
      accountNumber
      secondaryAccountIdentifier
      serviceAddressZip
      serviceAddressState
      serviceAddressCity
      serviceAddressStreetOne
      enrollmentDataSourceName
      serviceAddressStreetTwo
      account {
        id
        businessName
        customerType
      }
      user {
        id
        firstName
        lastName
        email
        metaData
        originationSource {
          originationSourceType
          funnel
          enrollmentExperience
          queryParams
        }
        phoneNumber: phone
        zipCode: zip
        signupPromoCode {
          code
        }
        phone
      }
      utility {
        ...UtilityData
      }
      utilityCredential {
        id
        username
        verificationStatus
      }
      utilityAccountMissingError
    }
    unparsedQueryParams {
      utilityAccountNumber
      secondaryAccountId
      meterNumber
      annualizedUsageEstimate
    }
  }
  ${UTILITY_FRAGMENT}
`;

export const FETCH_FUNNEL_PACKET = gql`
  query Flex_FetchFunnelPacket(
    $accountId: Int
    $customPlanId: Int
    $userId: Int!
    $utilityAccountId: Int
  ) {
    funnelPacket(
      accountId: $accountId
      customPlanId: $customPlanId
      userId: $userId
      utilityAccountId: $utilityAccountId
    ) {
      ...FunnelPacketData
    }
  }
  ${FUNNEL_PACKET_FRAGMENT}
`;
